var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nandu-ring",attrs:{"role":"img","aria-label":_vm.label}},[_c('div',{ref:"chart",staticClass:"nandu-ring__chart"}),_c('div',{staticClass:"nandu-ring__caption"},[_c('strong',[_vm._v(_vm._s(_vm.value))]),(_vm.unit)?_c('span',[_vm._v(_vm._s(_vm.unit))]):_vm._e(),(_vm.caption)?_c('small',[_vm._v(_vm._s(_vm.caption))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }